import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class CartProgressBarComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    
    // Listen for cart updates
    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate.bind(this));
    document.addEventListener('cart:change', this.#handleCartUpdate.bind(this));
    
    // Update initial values
    this.#handleCartUpdate();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate.bind(this));
    document.removeEventListener('cart:change', this.#handleCartUpdate.bind(this));
  }

  /**
   * Handle cart updates
   */
  #handleCartUpdate = async () => {
    try {
      // Get current cart
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Get free shipping threshold from data attribute
      const threshold = parseInt(this.dataset.threshold || 0);
      
      // Calculate remaining amount
      const remaining = threshold - cart.total_price;
      const progress = Math.min(100, (cart.total_price / threshold) * 100);
      
      // Update progress bar
      const progressBar = this.querySelector('.cart-progress__fill');
      if (progressBar) {
        progressBar.style.width = `${progress}%`;
        progressBar.dataset.progress = progress;
      }
      
      // Update text
      const progressText = this.querySelector('text-component[ref="progressText"]');
      if (progressText) {
        if (remaining > 0) {
          const formattedRemaining = window.Shopify?.formatMoney ? 
            window.Shopify.formatMoney(remaining) : 
            `€${(remaining / 100).toFixed(2).replace('.', ',')}`;
          
          // Update the text component
          progressText.setAttribute('value', formattedRemaining);
          progressText.textContent = Theme.translations.content.cart_progress_remaining.replace('{{ amount }}', formattedRemaining);
        } else {
          progressText.parentElement.innerHTML = `<span class="cart-progress__amount cart-progress__amount--complete">${Theme.translations.content.cart_progress_complete}</span>`;
        }
      } else {
        console.warn('Progress text element not found');
      }
    } catch (error) {
      console.error('Error updating cart progress:', error);
    }
  }
}

if (!customElements.get('cart-progress-bar')) {
  customElements.define('cart-progress-bar', CartProgressBarComponent);
}

export default CartProgressBarComponent;
